import { useSyncExternalStore } from 'react';

import { GetBackendVersionResponse } from '@Common/types/bo/backend_version';

let current: GetBackendVersionResponse | undefined;
const listeners = new Set<() => void>();

/** Shares the backend version fetched by the Version component with the rest of the UI */
export const setBackendVersion = (version: GetBackendVersionResponse) => {
  current = version;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const useBackendVersion = () => useSyncExternalStore(subscribe, () => current);
